import { Stack } from "expo-router";
import React from "react";

export default function MyGroupsLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" options={{ title: "My Groups" }} />
      <Stack.Screen name="[id]" options={{ title: "Edit Group" }} />
      <Stack.Screen name="new" options={{ title: "New Group" }} />
    </Stack>
  );
}
